import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/pro-regular-svg-icons/faList";
import axios from "axios";
import { useConfig } from "@peracto/peracto-config";

let Icon = () => (
    <div className="flex py-10 justify-center items-center w-full">
        <FontAwesomeIcon icon={faList} size="6x" />
    </div>
);

const MenuItemsComponent = ({
    state: {
        menuItemPath,
        categoryPath = "category",
        itemLimit = 4,
        heading = "",
    },
    isEditMode,
}) => {
    const config = useConfig();
    const API_URL = config.get("api");
    const [menuItemData, setMenuItemData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);

    useEffect(() => {
        if (menuItemPath) {
            const loadMenuItems = async () => {
                setLoadingError(false);
                const path =
                    menuItemPath[0] === "/"
                        ? menuItemPath.substr(1)
                        : menuItemPath;
                try {
                    axios
                        .get(`${API_URL}/menu-items-children-by-path/${path}`)
                        .then((res) => {
                            const data = res.data && res.data["hydra:member"];

                            if (data) {
                                setMenuItemData(data);
                                setIsLoading(false);
                            }
                        })
                        .catch((error) => {
                            setLoadingError(true);
                            return Promise.reject(error);
                        });
                } catch (e) {
                    console.error(e);
                    setLoadingError(true);
                }
            };

            loadMenuItems();
        }
    }, [API_URL, menuItemPath]);

    if (loadingError) {
        // this has padding so the element is at least clickable so it can be selected and edited
        return <div className="py-10 w-full"></div>;
    }

    const inStorefront = !window?.location?.pathname.includes("/content/edit/");

    return (
        <>
            {heading && (
                <h2 className="text-center !mb-[30px] !text-[30px] !leading-[36px] !lg:text-[40px] !lg:leading-[46px] font-extrabold">
                    {heading}
                </h2>
            )}

            <div
                className={`max-w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[30px] content-menu-items content__menu-items`}
            >
                {menuItemPath ? (
                    <>
                        {menuItemData?.length > 0 && itemLimit > 0
                            ? menuItemData
                                  .slice(0, itemLimit)
                                  .map((menuItem, index) => {
                                      if (
                                          !menuItem.path ||
                                          menuItem.itemType === "branch"
                                      ) {
                                          return null;
                                      }
                                      let path =
                                          !menuItem.path.startsWith("http") &&
                                          menuItemPath[0] !== "/"
                                              ? `/${menuItem.path}`
                                              : menuItem.path;

                                      if (
                                          menuItem.itemType === "category" &&
                                          !menuItem.path.startsWith(
                                              `/${categoryPath}/`
                                          )
                                      ) {
                                          path = `/${categoryPath}${path}`;
                                      }

                                      const image =
                                          menuItem.content?.image ||
                                          menuItem.image ||
                                          "/images/placeholder.png";

                                      const decodedImage = image
                                          ?.replaceAll("(", "%28")
                                          ?.replaceAll(")", "%29");

                                      return (
                                          <a
                                              href={path}
                                              onClick={(e) => {
                                                  e.preventDefault();
                                                  if (isEditMode) return;

                                                  window.location = path;
                                              }}
                                              className={`content-menu-items__item flex flex-col gap-[15px]  bg-no-repeat items-center text-center !no-underline !text-brand-black bg-brand-light-grey p-[30px] rounded-[10px] aspect-[275/220] md:aspect-auto h-full`}
                                              key={`menu_item_${index}`}
                                          >
                                              <span
                                                  className={`content-menu-items__link-text font-extrabold text-center text-[20px] leading-[26px] flex-grow !no-underline !text-brand-black`}
                                                  data-testid="content-menu-items__link-text"
                                              >
                                                  {menuItem.linkText}
                                              </span>

                                              <span
                                                  className="aspect-square w-full max-h-[75%] md:max-h-[240px] lg:max-h-[190px] bg-contain bg-center bg-no-repeat"
                                                  style={{
                                                      backgroundImage: `url("${decodedImage}")`,
                                                      backgroundColor:
                                                          !decodedImage &&
                                                          "#f7f7f7",
                                                  }}
                                              ></span>
                                          </a>
                                      );
                                  })
                            : !isLoading && "No Menu Items"}
                    </>
                ) : inStorefront ? (
                    <></>
                ) : (
                    <Icon />
                )}
            </div>
        </>
    );
};

export default MenuItemsComponent;
